<template>
  <div class="one-request">
    <h2 class="text__center">{{ type.name }} Request</h2>
    <p class="m-tb-md">
      <router-link :to="`/${type.url}`">{{type.url}}/</router-link>
      {{ getActive.name }}
    </p>
    <slot></slot>
    <OverallStatusBlock :active="getActive" />
    <div class="tile--grid">
      <StatusBlock
        v-for="service in getActiveServices"
        :key="service._id"
        :service="service"
        :type="type.url"
        :namespace="type.namespace"
      />
    </div>
    <div class="tile">
      <p class="content__heading">Change Services Displayed</p>
      <div class="flex__around flex__wrap">
        <DeleteService :active="getActive" :type="type" />
        <AddService :active="getActive" :type="type" />
        <div class="one-request--notes">
          <p class="text__bold text__center text__red m-tb-small">Delete Notes</p>
          <ul class="list__normal">
            <li>Marking a request inactive for future requests will not remove it from this request, you must delete it from this request.</li>
            <li>Removing a service from this request will not remove it permanently, but it will remove it from site and update the Overall Status of this request.</li>
          </ul>
          <p class="text__bold text__center text__green m-tb-small">Add Notes</p>
          <ul class="list__normal">
            <li>Adding a service to this request will not mark that service active for future requests.</li>
            <li>You may only add services to this request which already exist. They may be active or inactive.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OverallStatusBlock from "./OverallStatusBlock";
import StatusBlock from "./StatusBlock";
import DeleteService from "./DeleteService";
import AddService from "./AddService";

export default {
  props: ["type", "name"],
  components: {
    OverallStatusBlock,
    StatusBlock,
    DeleteService,
    AddService
  },
  data() {
    return {
      form: {
        removal: ""
      }
    };
  },
  computed: {
    getActive() {
      return this.$store.getters[`${this.type.namespace}/getActive`];
    },
    getActiveServices() {
      return this.getActive.services.filter(service => {
        return service.active;
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>